export default __webpack_public_path__ + "static/media/logo-full.4d44d899.svg";